import { render, staticRenderFns } from "./StudentCreditPolicyForm.vue?vue&type=template&id=00730498&scoped=true"
import script from "./StudentCreditPolicyForm.vue?vue&type=script&lang=js"
export * from "./StudentCreditPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00730498",
  null
  
)

export default component.exports